module.exports = __webpack_public_path__ + "assets/img/ISS_10035_27331.d7d55f95.png";